"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const date_inputs_1 = require("@kyruus/date-inputs");
const intl_1 = require("@kyruus/intl");
const button_1 = __importDefault(require("@kyruus/button"));
const banner_1 = __importDefault(require("@kyruus/banner"));
const messages_1 = __importDefault(require("./lib/messages"));
const Tracking_1 = require("./lib/Tracking");
const useWindowWidth_1 = __importDefault(require("../../../lib/useWindowWidth"));
const utils_1 = require("../../../lib/utils");
const styles_1 = require("./styles");
const Banners_1 = require("../../../components/Banners");
const States_1 = __importDefault(require("../../lib/constants/States"));
const Events_1 = require("../../lib/constants/Events");
const react_2 = require("@xstate/react");
const react_intl_1 = require("react-intl");
const ContinueButton = ({ onContinue }) => {
    const { formatMessage } = (0, react_intl_1.useIntl)();
    return (react_1.default.createElement(styles_1.ContinueButtonContainer, null,
        react_1.default.createElement(button_1.default, { mode: "primary", onClick: onContinue, "data-testid": "continue-button", "aria-label": formatMessage(messages_1.default.ariaConfirmDateOfBirthContinueButtonLabel) },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.continueButton)))));
};
const DobConfirmationFooter = ({ aboveMd, onContinue }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, aboveMd ? (react_1.default.createElement(ContinueButton, { onContinue: onContinue })) : (react_1.default.createElement(styles_1.FixedFooterContainer, null,
        react_1.default.createElement(ContinueButton, { onContinue: onContinue })))));
};
const ConfirmDOBPage = ({ track, service }) => {
    var _a;
    const [dateOfBirth, setDateOfBirth] = (0, react_1.useState)(null);
    const [showValidationError, setShowValidationError] = (0, react_1.useState)(false);
    const { aboveMd } = (0, useWindowWidth_1.default)();
    const [currentState] = (0, react_2.useService)(service);
    const { context } = currentState;
    const handleDateChange = (dateResponse) => {
        var _a;
        // Parse year, month, day as numbers
        const year = Number(dateResponse.year);
        const month = Number(dateResponse.month) - 1; // JS months are 0-based
        const day = Number(dateResponse.day);
        // Create a UTC date
        const utcDate = new Date(Date.UTC(year, month, day));
        // Replace the date in dateResponse with the UTC date
        const correctedDateResponse = Object.assign(Object.assign({}, dateResponse), { date: utcDate });
        setDateOfBirth(correctedDateResponse);
        // Show validation error if the date is invalid after user interaction
        const hasValidDate = dateResponse.date !== null && dateResponse.errors.length === 0;
        const hasAllFields = dateResponse.month && dateResponse.day && dateResponse.year;
        setShowValidationError(Boolean(hasAllFields && !hasValidDate));
        // Track date selection for analytics
        track(Tracking_1.userEvents.WAITLIST_DOB_CONFIRMED, {
            dateEntered: (_a = dateResponse.date) === null || _a === void 0 ? void 0 : _a.toISOString(),
            hasErrors: dateResponse.errors.length > 0
        });
    };
    const handleContinueClick = () => {
        var _a;
        const hasValidDate = (dateOfBirth === null || dateOfBirth === void 0 ? void 0 : dateOfBirth.date) !== null && (((_a = dateOfBirth === null || dateOfBirth === void 0 ? void 0 : dateOfBirth.errors) === null || _a === void 0 ? void 0 : _a.length) || 0) === 0;
        const hasAllFields = (dateOfBirth === null || dateOfBirth === void 0 ? void 0 : dateOfBirth.month) && (dateOfBirth === null || dateOfBirth === void 0 ? void 0 : dateOfBirth.day) && (dateOfBirth === null || dateOfBirth === void 0 ? void 0 : dateOfBirth.year);
        if (!hasValidDate || !hasAllFields) {
            setShowValidationError(true);
            track(Tracking_1.userEvents.WAITLIST_CONTINUE_CLICKED, {
                dobCompleted: false,
                validationError: 'missing_or_invalid_dob'
            });
            return;
        }
        setShowValidationError(false);
        track(Tracking_1.userEvents.WAITLIST_CONTINUE_CLICKED, {
            dobCompleted: true
        });
        // Send VALIDATE_DATE event to state machine
        service.send({
            type: Events_1.VALIDATE_DATE,
            data: {
                dateOfBirth: dateOfBirth
            }
        });
    };
    // Format dynamic data for dobInfoMessage
    const formatDynamicMessageData = () => {
        var _a, _b, _c, _d;
        const originalAppointment = (_a = context === null || context === void 0 ? void 0 : context.waitlist) === null || _a === void 0 ? void 0 : _a.original_appointment;
        if (!originalAppointment) {
            return {
                provider_name: '',
                appointment_time: ''
            };
        }
        // Format provider name
        const providerName = (0, utils_1.makeNameString)({
            first: (_b = originalAppointment.provider) === null || _b === void 0 ? void 0 : _b.first_name,
            middle: (_c = originalAppointment.provider) === null || _c === void 0 ? void 0 : _c.middle_name,
            last: (_d = originalAppointment.provider) === null || _d === void 0 ? void 0 : _d.last_name
        });
        // Format appointment date and time
        const formattedAppointmentDate = (0, utils_1.getAppointmentDate)({ start_datetime: originalAppointment.start_datetime }, 'dddd, MMMM DD, YYYY');
        return {
            provider_name: `Dr. ${providerName}`,
            appointment_time: `${formattedAppointmentDate === null || formattedAppointmentDate === void 0 ? void 0 : formattedAppointmentDate.formattedDate} at ${formattedAppointmentDate === null || formattedAppointmentDate === void 0 ? void 0 : formattedAppointmentDate.formattedTime}`
        };
    };
    const dateInputConfig = {
        label: (react_1.default.createElement(styles_1.DobLabel, null,
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.dobLabel)))),
        required: true,
        month: {
            label: 'Month *',
            name: 'dob-month',
            placeholder: 'MM',
            autoComplete: 'bday-month',
            ariaDescription: 'Enter your birth month (01-12). This will automatically focus to the day field.',
            invalidMsg: '',
            isRequiredMsg: '' // Remove individual error messages
        },
        day: {
            label: 'Day *',
            name: 'dob-day',
            placeholder: 'DD',
            autoComplete: 'bday-day',
            ariaDescription: 'Enter your birth day (01-31). This will automatically focus to the year field.',
            invalidMsg: '',
            isRequiredMsg: '' // Remove individual error messages
        },
        year: {
            label: 'Year *',
            name: 'dob-year',
            placeholder: 'YYYY',
            autoComplete: 'bday-year',
            ariaDescription: 'Enter your birth year (4 digits).',
            invalidMsg: '',
            isRequiredMsg: '' // Remove individual error messages
        }
    };
    return (react_1.default.createElement(styles_1.DobConfirmationContainer, { "data-testid": "dob-confirmation-container", style: !aboveMd ? { paddingBottom: '88px' } : undefined }, ((_a = context === null || context === void 0 ? void 0 : context.waitlist) === null || _a === void 0 ? void 0 : _a.eligible_cached_availability) === 0 ? (react_1.default.createElement(banner_1.default, { type: "warning", icon: "!", "data-testid": "dob-info-banner" },
        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.dobInfoMessage, { values: formatDynamicMessageData() })))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.DobConfirmationBody, null,
            currentState.matches(States_1.default.validateFailure) && (react_1.default.createElement(Banners_1.WarningBanner, null,
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.dobValidationFailureBanner)))),
            react_1.default.createElement(styles_1.Heading, null,
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.dobConfirmationHeading))),
            react_1.default.createElement(styles_1.DateInputContainer, null,
                react_1.default.createElement(styles_1.EqualWidthDateInputWrapper, null,
                    react_1.default.createElement(date_inputs_1.SeparateNumericsDateInput, { label: dateInputConfig.label, required: dateInputConfig.required, month: dateInputConfig.month, day: dateInputConfig.day, year: dateInputConfig.year, onChange: handleDateChange, errors: showValidationError
                            ? [
                                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({ key: "dob-error" }, messages_1.default.dobValidationError))
                            ]
                            : [] })))),
        react_1.default.createElement(DobConfirmationFooter, { onContinue: handleContinueClick, aboveMd: aboveMd })))));
};
exports.default = ConfirmDOBPage;
//# sourceMappingURL=ConfirmDOBPage.js.map